import { FCX } from "@datassential/platform-ui-lib";
import './Widget.scss';
import { ReactNode } from "react";
import cn from "classnames";

const FoodWidget: FCX<{
    headerContent?: ReactNode;
}> = ({
    headerContent,
    children,
    className,
    style,
    testId
}) => {
    return (
        <div
            className={cn("FoodWidget", className)}
            data-testid={testId}
            style={style}
        >
            {headerContent && (
                <div
                    className="FoodWidget__header"
                    // data-testid="blockFoodWidgetHeader"
                >
                    {headerContent}
                </div>
            )}
            <div
                className="FoodWidget__content"
                // data-testid="blockFoodWidgetContent"
            >
                {children}
            </div>
        </div>
    );
};

export default FoodWidget;